import React from 'react';
import Image from 'next/image';
import JobFutureCard from './JobFutureCard';
import JobFutureAmountCard from './JobFutureAmountCard';
import JobFutureSalaryCard from './JobFutureSalaryCard';
import JobFutureExperienceCard from './JobFutureExperienceCard';
import { TAB_MAP, TAB_JOB_FUTURE } from '@/constants/job-title';
import jobIcon from '@/assets/job-title/job.svg';

const JobFuture = () => {
  return (
    <div className="job-future-tab">
      <div className="font-semibold text-2xl flex items-center mb-9 tablet:mb-10">
        <Image src={jobIcon} alt="job future icon" width={24} height={24} />
        <h2 className="ml-2 opacity-85">{TAB_MAP[TAB_JOB_FUTURE]}</h2>
      </div>
      <JobFutureCard />
      <JobFutureAmountCard />
      <JobFutureSalaryCard />
      <JobFutureExperienceCard />
    </div>
  );
};

export default JobFuture;
